"use client";

import { Conduct } from "./Conduct";

export const PageCodeOfConduct = () => {
  return <Conduct />;
};
